import { AutogenModelStopRecOrder, AutogenRowStopRecOrder } from "./autogen/AutogenModelStopRecOrder";

export class ModelStopRecOrder extends AutogenModelStopRecOrder<RowStopRecOrder> {
    constructor() {
        super(RowStopRecOrder);
    }
}

export class RowStopRecOrder extends AutogenRowStopRecOrder {
}